import { ReferenceManyField, TextField } from 'react-admin';
import { CheckRecordActiveSwitch } from '@/pages/Candidate/view/utils';
import { MainDatagridStyled } from '@/styles/overrides';
import { FCRAWorkerCheckRecordTypeEnum, TurnReferencesEnum, TurnTargetsEnum } from '@/types/turn-enums';
import AccordionWrapper from '../AccordionWrapper';
import { path } from '../constants';

const Accidents = () => {
  return (
    <AccordionWrapper title="Accidents">
      <ReferenceManyField
        label={false}
        reference={TurnReferencesEnum.Candidates}
        target={TurnTargetsEnum.WorkerMvrAccidents}
      >
        <MainDatagridStyled bulkActionButtons={false} rowClick={false}>
          <CheckRecordActiveSwitch type={FCRAWorkerCheckRecordTypeEnum.MvrAccident} />
          <TextField emptyText="false" sortable={false} source={path('active')} />
          <TextField label="ID" sortable={false} source={path('id')} />
          <TextField label="Incident Date" sortable={false} source={path('incident_date')} />
          <TextField label="Docket" sortable={false} source={path('locations.0.docket')} />
          <TextField
            label="Short Description"
            sortable={false}
            source={path('sub_violations.0.descriptions.0.short_description')}
          />
          <TextField
            label="State Description"
            sortable={false}
            source={path('sub_violations.0.descriptions.0.state_description')}
          />
        </MainDatagridStyled>
      </ReferenceManyField>
    </AccordionWrapper>
  );
};

export default Accidents;
